import { defineComponent, reactive, ref, useCssModule } from '@nuxtjs/composition-api';
import { CONFIG } from './';
import { ADFOX_FETCH_STATES } from '~/components/Adfox';
import { SCRIPT_SRC } from '~/components/Sparrow';
export default defineComponent({
    name: 'SparrowMobile',
    emits: ['complete'],
    setup(_, { emit }) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const bannerEl = ref();
        const error = reactive({});
        const state = reactive({ ...ADFOX_FETCH_STATES });
        function handleIntersect({ observer }) {
            const scriptEl = document.head.querySelector(`script[src="${SCRIPT_SRC}"]`);
            if (scriptEl) {
                initSparrow();
                observer.disconnect();
            }
            else {
                const script = document.createElement('script');
                script.async = true;
                script.src = SCRIPT_SRC;
                script.onerror = () => {
                    return throwError(`Error in script "${SCRIPT_SRC}"`);
                };
                script.onload = () => {
                    initSparrow();
                    observer.disconnect();
                };
                document.head.append(script);
            }
        }
        function initSparrow() {
            state.isLoaded = true;
            window._svk_n_widgets = window._svk_n_widgets || [];
            window._svk_n_widgets.push({ ...CONFIG });
            if (!window._SVKNative_embed) {
                return throwError(`There is no '_SVKNative_embed' in window`);
            }
            window._SVKNative_embed.initWidgets();
            state.isRendered = true;
            state.isCompleted = true;
            emit('complete', { error, state });
        }
        function throwError(message = '', payload = '') {
            state.withError = true;
            error.message = message;
            console.error('[SparrowMobile]', message, payload);
        }
        return {
            CONFIG,
            bannerEl,
            css,
            error,
            handleIntersect,
            state,
        };
    },
});
